import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/panda/css';
import { getFontInfoForGlyph, getIconForGlyph, getSubcategoryIconStyle } from '@repo/types/maps/map-utils';
import type React from 'react';
import { ChecklistCard } from './checklist-card';
import type { SubcategoryStats } from './checklist-utils';
interface ChecklistSubcategoryCardProps {
  subcategory: SubcategoryStats;
  imageUrl: string | null;
  onClick: () => void;
  contextMenuItems?: React.ReactNode;
}
export const ChecklistSubcategoryCard: React.FC<ChecklistSubcategoryCardProps> = t0 => {
  const $ = _c(16);
  const {
    subcategory,
    imageUrl,
    onClick,
    contextMenuItems
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      width: "[32px]",
      height: "[32px]",
      borderRadius: "full",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "[0]",
      fontSize: "2xl",
      color: "white",
      marginLeft: "[5px]"
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== subcategory.icon) {
    t2 = getSubcategoryIconStyle(getFontInfoForGlyph(subcategory.icon).fontName);
    $[1] = subcategory.icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== subcategory.icon) {
    t3 = getIconForGlyph(subcategory.icon);
    $[3] = subcategory.icon;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t1} style={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const glyphIcon = t4;
  let t5;
  if ($[8] !== contextMenuItems || $[9] !== glyphIcon || $[10] !== imageUrl || $[11] !== onClick || $[12] !== subcategory.foundItems || $[13] !== subcategory.title || $[14] !== subcategory.totalItems) {
    t5 = <ChecklistCard imageUrl={imageUrl} icon={glyphIcon} title={subcategory.title} foundCount={subcategory.foundItems} totalCount={subcategory.totalItems} onClick={onClick} contextMenuItems={contextMenuItems} />;
    $[8] = contextMenuItems;
    $[9] = glyphIcon;
    $[10] = imageUrl;
    $[11] = onClick;
    $[12] = subcategory.foundItems;
    $[13] = subcategory.title;
    $[14] = subcategory.totalItems;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};